/**
 * @Author: v_jppjpeng
 * @Date: 2023-07-26 19:44:36
 * @Explain: Dialog 封装
 */
import { intlGet } from '@/locales';
import classNames from 'classnames';
import { useEffect, useState } from 'react';
import type { DialogProps } from 'tdesign-react';
import { Dialog as TDialog } from 'tdesign-react';
import Button from '../button';
// type

export type PropsType = {
  className?: string;
  children?: React.ReactNode;
  visible: boolean;
  header?: DialogProps['header'];
  footer?: DialogProps['footer'];
  width?: string | number;
  placement?: DialogProps['placement'];
  /** 是否在关闭弹框的时候销毁子元素 */
  destroyOnClose?: boolean;
  /** 是否点击蒙层时是否触发关闭事件 */
  closeOnOverlayClick?: boolean;
  /** 是否正在提交 */
  isSubmit?: boolean;
  /** 是否展示右上角关闭按钮 */
  isShowRightClose?: boolean;
  /** 是否展示按钮 */
  isShowBtn?: boolean;
  /** 取消按钮文字  */
  cancelBtnText?: string;
  /** 确认按钮文字 */
  confirmBtnText?: string;
  /** 确认按钮 - 禁用 */
  confirmBtnDisabled?: boolean;
  /** 弹窗props */
  dialogProps?: DialogProps;
  cancelBtnProps?: any;
  confirmBtnProps?: any;
  onClose?: () => void;
  onCancel?: () => void;
  onConfirm?: () => void;
  // 挂载的父级元素 string|function
  attach?: DialogProps['attach'];
  closeBtn?: boolean;
};
function Dialog(props: PropsType) {
  const {
    className,
    children,
    visible,
    header,
    footer,
    width,
    placement,
    destroyOnClose,
    closeOnOverlayClick = false,
    isSubmit,
    isShowRightClose = true,
    isShowBtn = true,
    cancelBtnText,
    confirmBtnText,
    confirmBtnDisabled = false,
    dialogProps,
    cancelBtnProps,
    confirmBtnProps,
    onClose,
    onCancel,
    onConfirm,
    attach,
    closeBtn,
  } = props;
  const [isConfirm, setIsConfirm] = useState<boolean>(false);

  useEffect(() => {
    if (isConfirm) {
      onConfirm?.();
    }
    return () => setIsConfirm(false);
  }, [isConfirm]);

  return (
    <TDialog
      attach={attach}
      className={classNames(
        'default-td-dialog',
        {
          // 隐藏右上角的关闭(X)按钮
          'hide-right-close': !isShowRightClose,
          // 隐藏底部按钮
          'hide-footer-btn': !isShowBtn,
          // 关闭按钮样式
          'close-btn': closeBtn,
        },
        className,
      )}
      visible={visible}
      header={header}
      footer={footer}
      width={width}
      placement={placement}
      destroyOnClose={destroyOnClose}
      closeOnOverlayClick={closeOnOverlayClick}
      closeBtn={closeBtn}
      cancelBtn={
        isShowBtn && (
          <Button
            useType="cancel"
            theme="default"
            onClick={() => {
              if (onCancel) {
                onCancel?.();
              } else {
                onClose?.();
              }
            }}
            disabled={isSubmit}
            {...cancelBtnProps}
          >
            {cancelBtnText || intlGet('COMMON.CANCEL')}
          </Button>
        )
      }
      confirmBtn={
        isShowBtn && (
          <Button
            onClick={() => setIsConfirm(true)}
            disabled={confirmBtnDisabled}
            loading={isSubmit}
            {...confirmBtnProps}
          >
            {isSubmit ? '' : confirmBtnText || intlGet('COMMON.CONFIRM')}
          </Button>
        )
      }
      onClose={onClose}
      {...dialogProps}
    >
      {children}
    </TDialog>
  );
}

export default Dialog;
